import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';
import update from 'immutability-helper';

import TourTodoItem from './TourTodoItem';
import { acceptedStates, pendingStates, displayBuyerBidState } from '../../../core/api';

class TourTodo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hotelsSelected: false,
      hotelsRequested: false,
      hotelsAccepted: false,
      hotelsNeededCount: 0,
      hotelsSelectedCount: 0,
      hotelsAcceptedCount: 0,
      hotelsPendingCount: 0,
      hotelsReviewableCount: 0,
      roomCount: 0,
    };
  }
  componentWillMount() {
    this.loadData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.tour.id !== this.props.tour.id) {
      this.loadData(nextProps);
    } else if (nextProps.bidNeedFetch || nextProps.proposalNeedFetch) {
      this.loadData(nextProps);
    }
  }

  getRoomCount(tour) {
    // all groups must have non-zero room count
    let roomCount = 0;
    for (let i = 0, len = tour.groups.length; i < len; i++) {
      const rooms =
        tour.groups[i].hotel_prefs.kings +
        tour.groups[i].hotel_prefs.kings +
        tour.groups[i].hotel_prefs.suites;
      if (rooms === 0) {
        return 0;
      }
      roomCount += rooms;
    }
    return roomCount;
  }
  loadData(props) {
    if (props.bidNeedFetch) {
      this.props.requestBidsets(props.tour.id);
    }
    if (props.proposalNeedFetch) {
      this.props.requestProposals(props.tour.id);
    }
  }

  processStops(tour) {
    const hotels = { needed: 0, accepted: 0, selected: 0, reviewable: 0, stops: {} };
    for (let i = 0, len = tour.tour_stops.length; i < len; i++) {
      const groupEvents = tour.tour_stops[i].related_group_events;
      for (let j = 0, len2 = groupEvents.length; j < len2; j++) {
        if (groupEvents[j].event_type === 'stay') {
          hotels.needed += 1;
          hotels.stops[groupEvents[j].id] = { accepted: false, selected: false };
        }
      }
    }
    return hotels;
  }
  processBids(bids, tour, status) {
    // Look thru all the bids to see if a bid has been created for each stay
    // Also look for accepted bids in for each event
    const hotels = this.processStops(tour);
    if (!bids) {
      return update(status, {
        $merge: {
          hotelsAccepted: false,
          hotelsSelected: false,
          hotelsNeededCount: 0,
          hotelsSelectedCount: 0,
          hotelsAcceptedCount: 0,
          hotelsReviewableCount: 0,
        },
      });
    }
    if (bids.length === 0) {
      return update(status, {
        $merge: {
          hotelsAccepted: false,
          hotelsSelected: false,
          hotelsNeededCount: 0,
          hotelsSelectedCount: 0,
          hotelsAcceptedCount: 0,
          hotelsReviewableCount: 0,
        },
      });
    }
    for (let i = 0, len = bids.length; i < len; i++) {
      const eventId = bids[i].bidset.event.id;
      hotels.stops[eventId].selected = true;
      const state = bids[i].buyer_state;
      if (acceptedStates.includes(state)) {
        hotels.stops[eventId].accepted = true;
        hotels.accepted += 1;
      } else if (pendingStates.includes(state)) {
        hotels.reviewable += 1;
      }
    }
    let accepted = true;
    let selected = true;
    for (const [key, value] of Object.entries(hotels.stops)) {
      accepted = value.accepted && accepted;
      selected = value.selected && selected;
      if (value.selected) {
        hotels.selected += 1;
      }
    }
    return update(status, {
      $merge: {
        hotelsSelected: selected,
        hotelsAccepted: accepted,
        hotelsNeededCount: hotels.needed,
        hotelsSelectedCount: hotels.selected,
        hotelsAcceptedCount: hotels.accepted,
        hotelsReviewableCount: hotels.reviewable,
      },
    });
  }
  processProposals(proposals, status) {
    if (proposals.length === 0) {
      return update(status, {
        $merge: {
          hotelsRequested: false,
          hotelsSelected: false,
          hotelsPendingCount: 0,
        },
      });
    }
    const bidStatus = {};
    bidStatus.sent = 0;
    bidStatus.pending = 0;
    for (let i = 0, len = proposals.length; i < len; i++) {
      const bids = proposals[i].bids;
      this.countBids(bids, bidStatus);
    }
    console.log('Bids = ', bidStatus.sent, bidStatus.pending);
    return update(status, {
      $merge: {
        hotelsRequested: bidStatus.pending === 0 && bidStatus.sent > 0,
        hotelsPendingCount: bidStatus.pending,
      },
    });
  }
  countBids(bids, bidStatus) {
    for (let i = 0, len = bids.length; i < len; i++) {
      const displayState = displayBuyerBidState(bids[i].buyer_state, bids[i].bidder_state);
      if (['Sent', 'Sending'].includes(displayState)) {
        bidStatus.sent += 1;
      }
      if (['Draft'].includes(displayState)) {
        bidStatus.pending += 1;
      }
    }
  }
  render() {
    if (this.props.isFetching) {
      return (
        <div className="col-sm-3">
          <Panel header="Plan">
            <div className="tour-todo">
              <div className="text-center">
                <i className="fa fa-spinner fa-pulse fa-5x fa-fw" />
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </Panel>
        </div>
      );
    }
    const tour = this.props.tour;

    let status = {
      hotelsSelected: false,
      hotelsRequested: false,
      hotelsAccepted: false,
      hotelsNeededCount: 0,
      hotelsSelectedCount: 0,
      hotelsAcceptedCount: 0,
      hotelsPendingCount: 0,
      hotelsReviewableCount: 0,
      roomCount: 0,
    };
    // Calculate list status
    status.roomCount = this.getRoomCount(this.props.tour);
    status = this.processProposals(this.props.proposals, status);
    status = this.processBids(this.props.bids, this.props.tour, status);

    const rosterUrl = `/tours/${tour.id}/participants`;
    const hotelPrefUrl = `/tours/${tour.id}/hotels/3`;
    const hotelSelectUrl = `/tours/${tour.id}/hotels/2`;
    const hotelRequestUrl = `/tours/${tour.id}/hotels/3`;
    const hotelManageUrl = `/tours/${tour.id}/hotels/4`;
    const hotelRequestMsg = status.hotelsPendingCount
      ? `Request hotels bid (${status.hotelsPendingCount})`
      : 'Request hotel bids';
    const hotelManageMsg = status.hotelsReviewableCount
      ? `Accept hotels bid (${status.hotelsReviewableCount})`
      : 'Accept hotel bids';
    const todoItems = [];
    const todo = [
      {
        key: 'create-group',
        checked: tour.groups.length,
        message: 'Create group(s)',
        url: rosterUrl,
        pred: tour.tour_stops.length,
      },
      {
        key: 'import-route',
        checked: tour.tour_stops.length,
        message: 'Import Route',
      },
      {
        key: 'select-hotels',
        checked: status.hotelsSelected,
        message: `Select hotels (${status.hotelsSelectedCount}/${status.hotelsNeededCount})`,
        url: hotelSelectUrl,
        pred: tour.groups.length && tour.tour_stops.length,
      },
      {
        key: 'set-room',
        checked: status.roomCount,
        message: 'Set room count',
        url: hotelPrefUrl,
        pred: tour.groups.length && tour.tour_stops.length,
      },
      {
        key: 'hotel-req',
        checked: status.hotelsRequested,
        message: hotelRequestMsg,
        url: hotelRequestUrl,
        pred: status.hotelsSelected,
      },
      {
        key: 'add-tour-mgr',
        checked: tour.managers.length,
        message: 'Share with collaborators',
        url: hotelManageUrl,
        pred: status.hotelsSelected,
      },
      {
        key: 'hotel-manage',
        checked: status.hotelsAccepted,
        message: hotelManageMsg,
        url: hotelManageUrl,
        pred: status.hotelsSelected,
      },
      {
        key: 'tour-roster',
        checked: tour.members.length,
        message: 'Finalize the particpant list',
        url: rosterUrl,
        pred: status.hotelsSelected,
      },
      {
        key: 'tour-active',
        checked: tour.state === 'AC',
        message: 'Send mobile app to particpants',
        url: rosterUrl,
        pred: status.hotelsAccepted && tour.members.length,
      },
    ];

    todo.forEach(item => {
      todoItems.push(<TourTodoItem {...item} />);
    });

    return (
      <div className="col-sm-3">
        <Panel header="Plan">
          <div className="tour-todo">
            <ul>{todoItems}</ul>
          </div>
        </Panel>
      </div>
    );
  }
}
TourTodo.propTypes = {
  tour: PropTypes.object.isRequired,
  proposals: PropTypes.arrayOf(PropTypes.object).isRequired,
  bids: PropTypes.arrayOf(PropTypes.object).isRequired,
  requestBidsets: PropTypes.func.isRequired,
  requestProposals: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  bidNeedFetch: PropTypes.bool.isRequired,
  proposalNeedFetch: PropTypes.bool.isRequired,
};

export default TourTodo;



// WEBPACK FOOTER //
// src/routes/tours/components/TourTodo.js